import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import axios, { AxiosRequestConfig } from 'axios';

export const getBanner = async (
  discoveryApi: DiscoveryApi,
  identityApi: IdentityApi,
) => {
  const url = await discoveryApi.getBaseUrl('dev-portal');
  const { token } = await identityApi.getCredentials();

  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`${url}/banner`, config);

  return response.data as string;
};
